import type { ReactNode } from 'react'

import './screen.css'

export function Screen({
  title,
  body,
  action,
  children,
}: {
  title: string
  body?: string
  action?: { label: string; onClick: () => void }
  children?: ReactNode
}) {
  return (
    <main className="screen">
      <h1 className="screen__title">{title}</h1>
      {body ? <p className="screen__body">{body}</p> : null}
      {children}
      {action ? (
        <button className="screen__action" type="button" onClick={action.onClick}>
          {action.label}
        </button>
      ) : null}
    </main>
  )
}
